import $ from 'cash-dom'
import MicroModal from 'micromodal';
import {
    insertScript,
    insertLink,
    copyToClipboard
} from './utils';
import gdata from './gdata-slim';
let modalQueue = [];
let isOpenModal = false;
const titleHash = {};
export let _html;

export function addModalLib() {
    insertLink('https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/js/woay-modal.css');
    // insertLink('http://localhost:8888/js/woay-modal.css');// Local test
}

export function addFontIconLib() {
    insertLink('https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/fonts/sdk/style.css');
}

export function addToastifyLib() {
    insertScript('https://cdn.jsdelivr.net/npm/vanilla-toast@0.5.0/vanilla-toast.min.js');
    insertLink('https://cdn.jsdelivr.net/npm/vanilla-toast@0.5.0/vanilla-toast.min.css');
}

// Modal playcode 
export default class Html {
    constructor(eventBus) {
        this.eventBus = eventBus;
        this._t = 0;
        _html = this;
    }
    addPopupLib() {
        insertLink('https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/js/popup.css');
        // insertLink('http://localhost:8888/js/popup.css'); // Local test
    }
    getModalPlayCode(Options, {
        logo
    }) {
        if (Options.is_popup) return;
        return this.createModal({
            id: 'w-play-code',
            logo,
            title: 'Nhập mã chơi',
            form: [{
                name: 'Nhập mã tham gia',
                key: 'verify_code',
            }],
            custom_html: `<div class="w-error-log">Vui lòng nhập mã dự thưởng</div>`,
            buttons: [{
                id: 'w-play-code-submit-btn',
                name: 'Xác nhận',
                class: 'btn-primary',
            }]
        })
    }

    // Modal thông báo đăng nhập để tiếp tục
    getModalVerify(Options, data = {}) {
        if (Options.is_popup) return;
        var {
            logo,
            title,
        } = data;

        this.createModal({
            id: 'w-verify',
            title: title || 'Bạn cần đăng nhập để tiếp tục',
            logo,
            buttons: [{
                id: 'w-verify-submit-btn',
                class: 'btn-facebook',
                name: '<i class="fab fa-facebook-f"></i>Facebook'
            }]
        })
    }

    getModalVerifyZalo(Options, data = {}) {
        if (Options.is_popup) return;
        var {
            logo,
            title,
        } = data;

        this.createModal({
            id: 'w-verify-zalo',
            title: title || 'Bạn cần đăng nhập để tiếp tục',
            logo,
            buttons: [{
                id: 'w-verify-login-zalo',
                class: 'btn-zalo',
                name: 'Zalo'
            }]
        })
    }
    getModalVerifyGoogle(Options, data = {}) {
        if (Options.is_popup) return;
        var {
            logo,
            title,
        } = data;

        this.createModal({
            id: 'w-verify-google',
            title: title || 'Bạn cần đăng nhập để tiếp tục',
            logo,
            buttons: [{
                id: 'w-verify-login-google',
                class: 'btn-google',
                name: 'Google'
            }]
        })
    }
    // Modal hiện danh sách giải thưởng
    getModalRewards(Options, SETTINGS) {
        if (Options.is_popup) return;
        const {
            logo
        } = SETTINGS;
        return this.createModal({
            id: 'modal-reward-list',
            title: 'Phần thưởng đã trúng',
            logo,
            custom_html: `<div class="reward-list"><p>Chưa có phần thưởng</p></div>`
        });
    }
    getModalRewardTimeOut(SETTINGS) {
        const {
            logo
        } = SETTINGS;
        return this.createModal({
            id: 'modal-reward-time-out',
            title: 'Phiên truy cập của bạn đã hết',
            description: 'Nhấn "Tải lại trang" để tiếp tục',
            logo,
            close_button: false,
            close_backdrop: false,
            buttons: [{
                class: 'btn-primary',
                name: 'Tải lại trang',
                handler() {
                    window.location.reload();
                }
            }]
        })
    }

    getModalUnknownError(SETTINGS) {
        const {
            logo
        } = SETTINGS;
        return this.pushModal({
            title: 'Đã có lỗi xảy ra',
            description: 'Nhấn "Tải lại trang" để thử lại',
            close_button: false,
            close_backdrop: false,
            logo,
            buttons: [{
                class: 'btn-primary',
                name: 'Tải lại trang',
                handler() {
                    window.location.reload();
                }
            }]
        })
    }

    addLocationDataIntoForm(Wheel) {
        if (Wheel.form.province.enabled) {
            this.addGDataIntoForm();
        }
    }

    addGDataIntoForm() {
        var provinceHTML = '';
        if (gdata && gdata.city_data) {
            gdata.city_data.forEach(province => {
                provinceHTML += `<option value="${province.name}" data-id="${province.id}">${province.name}</option>`
            })
        }
        $('.w-province').html(provinceHTML);

        function renderDistrictData(gdata) {
            if (gdata && gdata.district_data) {
                var districtHTML = '';
                gdata.district_data.forEach(district => {
                    var province_id = $('.w-province option:checked').data('id');
                    if (province_id == district.province_id) {
                        districtHTML += `<option value="${district.name}">${district.name}</option>`
                    }
                })
            }
            return districtHTML;
        }

        $('.w-district').html(renderDistrictData(gdata));
        $('.w-province').on('change', function () {
            $('.w-district').html(renderDistrictData(gdata));
        })
    }

    getModalUserInfo(Options, {
        Wheel,
        logo,
        title_color,
        background
    }) {
        if (Options.is_popup) return;
        const keys = [
            "name",
            "phone",
            "email",
            "address",
            "identity",
            "province",
            "district",
            "add_data_1",
            "add_data_2",
            "add_data_3",
            "add_data_4",
            "custom_1",
            "custom_2",
            "custom_3",
            "custom_4",
            "custom_5",
            "custom_6",
            "custom_7",
            "custom_8",
            "custom_9",
            "password",
        ];
        const {
            SETTINGS
        } = Options;
        const {
            text_info_user_title,
            noti_submit_user_info,
        } = SETTINGS
        const fields = [],
            form = Wheel.form;
        for (var key of keys) {
            if (!form[key] || !form[key].enabled) continue;
            form[key].key = key;
            fields.push(form[key]);
        }

        return this.createModal({
            id: 'modal-woay-userinfo',
            title: text_info_user_title || "",
            description: 'Để nhận quà khi trúng giải',
            form: fields,
            logo,
            background: background,
            title_color: title_color,
            footer_text: noti_submit_user_info || "",
            buttons: [{
                id: 'btn-woay-form-submit',
                name: 'Xác nhận',
                class: 'btn-primary'
            }]
        })
    }

    getModalConfirm(Options, SETTINGS) {
        // TODO: implement in Lixi Game
        if (Options.is_popup) return;
        const {
            logo,
            gift_confirm,
            title_confirm
        } = SETTINGS;
        let close_texture = Options.Wheel.design.BACK_IMAGE;
        return this.pushModal({
            title: gift_confirm || 'Bạn có chắc muốn mở phần quà này',
            logo,
            custom_html: `<div class="w-box-img texture-img"><img src="${close_texture}"></div>`,
            buttons: [{
                id: 'w-confirm-cancel-btn',
                name: 'Hủy',
                class: 'btn-hotline',
            }, {
                id: 'w-confirm-submit-btn',
                name: title_confirm || 'Mở quà',
                class: 'btn-submit',
            }]
        });
    }

    getModalRefresh(SETTINGS) {
        // TODO: implement in Lixi Game
        const {
            logo
        } = SETTINGS;
        return this.pushModal({
            title: 'Bạn đã mở hết hộp quà',
            logo,
            buttons: [{
                id: 'w-refresh',
                name: 'Làm mới quà',
                class: 'btn-hotline',
            }]
        });
    }
    getModalOutOfTurn(Options, SETTINGS) {
        if (Options.is_popup) return;
        const {
            logo,
            button_group_index_1,
            button_group_index_3
        } = SETTINGS;
        const buttons = [];
        // Không chạy qua đây nếu không tồn tại
        if (button_group_index_1 && button_group_index_1.active) {
            buttons.push({
                name: button_group_index_1.title,
                class: 'btn-check-reward btn-primary',
                color: button_group_index_1.color,
                background: button_group_index_1.background
            })
        }
        if (Options.Wheel.scheme == 'tour' || Options.Wheel.scheme == 'mixed') {
            if (button_group_index_3 && button_group_index_3.active) {
                buttons.push({
                    name: button_group_index_3.title,
                    class: 'btn-get-mission btn-primary',
                    color: button_group_index_3.color,
                    background: button_group_index_3.background
                })
            }
        }
        return this.pushModal({
            background: SETTINGS.background_popup,
            title: 'Bạn đã hết lượt chơi',
            logo,
            buttons: buttons
        })
    }

    getPointsModal(Options, SETTINGS, Score, isEnoughPoinReward) {
        if (Options.is_popup) return;
        const {
            logo
        } = SETTINGS;
        if (Options.Wheel.scheme == 'quick' && Options.Wheel.game_type == 'flipcard') {

            if (isEnoughPoinReward) {
                console.log('case nhận quà');
                this.pushModal({
                    background: SETTINGS.background_popup,
                    logo,
                    title: 'Bạn đã đạt được ' + Score + ' điểm',
                    buttons: [{
                        id: 'w-submit-award',
                        class: 'btn-primary',
                        name: 'Mở quà'
                    }]
                })
                $('.w-modal.is-open').find('.modal__close').css('display', 'none');
            } else {
                console.log('case chơi lại');
                this.pushModal({
                    background: SETTINGS.background_popup,
                    logo,
                    title: 'Bạn đã đạt được ' + Score + ' điểm',
                    description: 'Rất tiếc, bạn chưa đạt đủ điểm để nhận quà',
                    buttons: [{
                        id: 'w-play-again',
                        class: 'btn-primary',
                        name: 'Chơi lại'
                    }]
                })
                $('.w-modal.is-open').find('.modal__close').css('display', 'block');
            }
        } else {
            this.pushModal({
                background: SETTINGS.background_popup,
                logo,
                title: 'Bạn đã đạt được ' + Score + ' điểm',
            })
        }
        return;
    }

    // Chưa xài tới modal này, cần implement TH đã hết quà.
    getModalNoItemLeft(SETTINGS) {
        const {
            logo
        } = SETTINGS;
        return this.pushModal({
            title: 'Đã hết quà',
            logo,
        })
    }

    getModalOutOfStock(SETTINGS) {
        const {
            logo
        } = SETTINGS;
        return this.pushModal({
            title: 'Hết mã trúng thưởng',
            logo,
        })
    }

    getModalTotalWinRate(SETTINGS) {
        const {
            logo
        } = SETTINGS;
        return this.pushModal({
            title: 'Tổng tỉ lệ = 0',
            logo,
        })
    }

    getModalErrorLogin(SETTINGS) {
        const {
            logo
        } = SETTINGS;
        return this.pushModal({
            title: 'Phiên đăng nhập không hợp lệ',
            description: 'Nhấn "Tải lại trang" để thử lại',
            close_button: false,
            close_backdrop: false,
            logo,
            buttons: [{
                class: 'btn-primary',
                name: 'Tải lại trang',
                handler() {
                    window.location.reload();
                }
            }]
        })
    }

    getReferralButton(Options) {
        // Nếu như tích hợp popup thì k chạy
        if (Options.is_popup) return;
        const {
            SETTINGS
        } = Options;
        $('#vongquaymayman, #lixi-game, .box-ctn').after(`<div class="ref-btn-ctn info-more-vongquay text-center">
            <div class="w-referral-text text-number-turns">
                Bạn còn
                <span class="w-r-times">01</span>
                lượt chơi
            </div>
            <div class="box-action">
                <div class="box-btn">
                    <a class="wheel-btn w-random-pick-btn btn-play"></a>
                    <a class="wheel-btn btn-check-reward" style="display:none"></a>
                </div>
            </div>
        </div>`)
        const $b1 = $('.btn-check-reward');
        const $b2 = $('.btn-play');
        if (SETTINGS.button_group_index_1 && SETTINGS.button_group_index_1.active) {
            const s = SETTINGS.button_group_index_1;
            $b1.css('color', s.color);
            $b1.css('background', s.background);
            $b1.html(s.title);
        } else {
            $b1.css('display', 'none');
        }
        if (SETTINGS.button_group_index_2 && SETTINGS.button_group_index_2.active) {
            const s = SETTINGS.button_group_index_2;
            $b2.css('color', s.color);
            $b2.css('background', s.background);
            $b2.html(s.title);
        } else {
            $b2.css('display', 'none');
        }
    }

    getModalReferral({
        logo
    }) {
        return this.createModal({
            id: 'w-share',
            title: 'Hãy chia sẻ cùng bạn bè',
            description: 'Với mỗi người tham gia, bạn sẽ nhận được thêm lượt chơi.',
            logo,
            custom_html: '<div class="input-copy-code copy-share-link-wrapper"><input type="text" id="w-text-share-url" class="code" value="unknow" aria-label="Code Prize" style="background: transparent;font-size: 14px;" readonly="readonly"></div>',
            buttons: [{
                class: 'btn-popup btn-facebook btn-share-fb my-social-btn--facebook',
                name: '<i class="wic-facebook2"></i> Share Facebook',
            }, {
                class: 'share-btn my-copy-link-btn btn-popup btn-info',
                name: '<i class="wic-link"></i>Copy Link'
            }]
        })
    }

    getModalQuiz({
        logo
    }) {
        return this.createModal({
            id: 'w-quiz',
            title: '',
            description: '',
            logo,
            custom_html: '<div class="title-question"></div><div id="box-question"></div>'
        })
    }

    getModalQrCode({
        logo
    }) {
        return this.createModal({
            id: 'w-qrcode',
            title: '',
            description: '',
            logo,
            custom_html: '<div class="text-qrcode"></div>'
        })
    }

    getModalVerifyHaravanOrder({
        logo
    }) {
        //TODO: handle sau
        return ``;
    }

    getLoading() {
        var loadingHtml = `
        <div id="loading" style="display: none;">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="object_one"></div>
                <div class="object" id="object_two"></div>
                <div class="object" id="object_three"></div>
                <div class="object" id="object_four"></div>
                </div>
            </div>
        </div>
        `
        return loadingHtml;
    }


    showLoading() {
        this._t = Date.now();
        $('#loading').css({
            'display': 'block'
        })
    }

    hideLoading() {
        var NOW = Date.now();
        var remain = Math.max(200 - (NOW - this._t), 0);
        setTimeout(() => {
            $('#loading').css({
                'display': 'none'
            })
        }, remain)
    }

    getGdata() {
        return gdata
    }

    add3rdPartyLib() {
        addModalLib();
        setTimeout(() => {
            addFontIconLib();
            addToastifyLib();
        }, 100);
    }
    injectHtml(Options) {
        const {
            Wheel,
            SETTINGS
        } = Options;
        const login_method = Wheel.login_method;
        var html = `<style>.w-modal {display:none}</style>`;
        var quantity;
        const {
            logo,
            close_texture,
            title_color,
            background,
        } = SETTINGS;
        if ($('#modal-woay-userinfo').length === 0) {
            this.getModalUserInfo(Options, {
                Wheel,
                logo,
                title_color,
                background
            });
        }

        if ($('#modal-reward-list').length === 0) {
            this.getModalRewards(Options, SETTINGS);
        }

        if ($('#w-complete').length === 0) {
            this.getModalComplete(SETTINGS);
        }

        if ($('#w-share').length === 0) {
            this.getModalReferral({
                logo
            });
        }

        if ($('#w-quiz').length === 0) {
            this.getModalQuiz({
                logo
            });
        }

        if ($('#w-qrcode').length === 0) {
            this.getModalQrCode({
                logo
            })
        }

        html += this.getLoading();

        if (login_method === 'play_code') {
            $('body').append(this.getModalPlayCode(Options, {
                logo
            }));
        }

        if (login_method === 'facebook') {
            this.getModalVerify(Options, SETTINGS);
        }

        if (login_method === 'zalo' || $('#w-verify-zalo').length === 0) {
            this.getModalVerifyZalo(Options, SETTINGS);
        }

        if (login_method === 'google' || $('#w-verify-google').length === 0) {
            this.getModalVerifyGoogle(Options, SETTINGS);
        }

        if ($('#lixi-game').length || $('#vongquaymayman').length || $('.box-ctn').length) {
            this.getReferralButton(Options)
        }

        $("body").append(html);
        setTimeout(() => {
            this.addLocationDataIntoForm(Wheel);
        }, 100)
    }

    updatePopupTitle(title) {
        var target = document.querySelector("#modal-woay-userinfo .title-popup");
        target.innerText = title;
    }

    updatePopupDescription(desc) {
        var target = document.querySelector("#modal-woay-userinfo .noti-submit");
        target.innerText = desc;
    }

    showReward(currentReward, Options) {
        if (Options.is_popup) return;
        const {
            SETTINGS
        } = Options;
        const {
            sku,
            code,
            name,
            item_type,
            reward_code
        } = currentReward;
        const reward_setting = Options.rewards.find(x => x.sku == sku);
        const reward_image = reward_setting.image;
        const imgHtml = reward_image ? `<div class="reward-img"><img src="${reward_image}"  alt=""></div>` : '';
        const {
            logo,
            voucher_small_title,
            voucher_apply,
            button_group_1,
            button_group_2,
            button_group_reward_1,
            button_group_reward_2,
        } = SETTINGS;
        $(document).on('click', '#btn-copy-code', function () {
            copyToClipboard('#w-text-code')
        });
        const $g1 = $('.box-btn .btn-inbox');
        const $g2 = $('.box-btn .btn-buy');
        const group1 = button_group_1 || button_group_reward_1;
        const group2 = button_group_2 || button_group_reward_2;
        const buttons = [];
        if (group1 && group1.active) {
            buttons.push({
                url: group1.url,
                name: group1.title,
                class: 'w-btn-first btn-popup btn-info btn-inbox',
                color: group1.color,
                background: group1.background
            })
        } else {
            $($g1).css('display', 'none');
        }
        if (group2 && group2.active) {
            buttons.push({
                url: group2.url,
                name: group2.title,
                class: 'w-btn-last btn-popup btn-success btn-buy',
                color: group2.color,
                background: group2.background
            })
        } else {
            $($g2).css('display', 'none');
        }
        let custom_html = `<div class="title-big title-popup color-orange">${name}</div>
                <div class="input-code copy-code">
                <input type="text" id="w-text-code" class="code" value="${code}" aria-label="Code Prize" 
                    style="background: transparent;border: none; font-size: 14px;" readonly="readonly">
                <a id="btn-copy-code" class="btn-copy btn-copy-code" aria-label="Copy mã"><i class="wic-copy"></i> Copy mã</a>
                </div>
            ${imgHtml}
            <div class="voucher-content text-tutorial" style="margin-bottom: 10px;">
            ${voucher_apply || ''}
            </div>`
        if (sku == 'BADLUCK') {
            custom_html = `<div class="title-big title-popup color-orange">${name}</div>${imgHtml}`
        }
        if (item_type == 'point') {
            custom_html = `<div class="title-big title-popup color-orange">${name}</div>
            ${imgHtml}
            <div class="voucher-content text-tutorial" style="margin-bottom: 10px;">
            ${voucher_apply || ''}
            </div>`
        }
        return this.pushModal({
            title: sku === 'BADLUCK' ? '' : (voucher_small_title || 'Chúc mừng bạn đã nhận được phần quà'),
            logo,
            custom_html,
            buttons: sku === 'BADLUCK' ? [] : buttons
        })
    }

    getModalComplete(SETTINGS) {
        const {
            logo
        } = SETTINGS
        return this.createModal({
            id: 'w-complete',
            title: '',
            logo,
        })
    }

    showRewardPopup(subject, currentReward) {
        //TODO: implement this
        alert('Trúng ' + currentReward.name)
    }

    closeAllModal(context) {
        // console.log('closeAllModal', context);
        $('.w-modal').each(function () {
            if ($(this).hasClass('is-open')) {
                const id = $(this).attr('id');
                // alert('closeAllModal kill ' + id);
                MicroModal.close(id);
            }
        })
    }
    renderTurn(times, testMode) {
        if (times < 1) {
            $('.text-number-turns').html('Bạn đã hết lượt chơi');
        }
        if (times >= 1) {
            $('.text-number-turns').html('Bạn còn ' + '<span class="w-r-times">' + times + '</span>' + ' lượt chơi');
        }
        if (times < 10) {
            times = '0' + times;
        }
        $('.w-r-times').html(times)
    }
    createModal(options) {
        var title = options.title || "";
        var description = options.description || "";
        var footer_text = options.footer_text || "";
        var logo = options.logo || "";
        var close_backdrop = options.close_backdrop || true;
        var close_button = options.close_button || true;
        var form = options.form || {};
        var buttons = options.buttons || [];
        var custom_html = options.custom_html;
        var background = options.background || '';
        var title_color = options.title_color || '';

        var h = $.parseHTML("<div class=\"w-modal\" aria-hidden=\"true\">\n    <div w-role=\"backdrop\" class=\"modal__overlay\" tabindex=\"-1\">\n        <div class=\"modal__container\" role=\"dialog\" aria-modal=\"true\">\n            <div class=\"modal__header\" w-role=\"header\">\n                <button w-role=\"close_button\" class=\"modal__close\" aria-label=\"Close modal\" data-micromodal-close=\"\">×</button>\n                <div class=\"logo-popup w-box-img\">\n                    <img w-role=\"logo\" src=\"./logo.png\">\n                </div>\n                <div class=\"title-popup\" w-role=\"title\"></div>\n            </div>\n            <div class=\"modal__content\">\n                <p w-role=\"description\"></p>\n                <div w-role=\"form\"></div>\n                <div class=\"w-error-alert\"></div>\n                <div w-role=\"custom_html\"></div>\n            </div>\n            <div class=\"modal__footer\">\n                <div w-role=\"button_group\" class=\"box-btn\">\n                </div>\n                <div class=\"noti-submit\" w-role=\"footer_text\">Vui lòng nhập đúng thông tin để nhận quà</div>\n            </div>\n        </div>\n    </div>\n</div>");
        var d = $(h[0]);
        $(document.body).append(d);

        d.find("[w-role=title]").text(title);
        d.find("[w-role=description]").text(description);
        d.find("[w-role=footer_text]").text(footer_text);
        if (logo) {
            d.find("[w-role=logo]").attr("src", logo);
        } else {
            d.find("[w-role=logo]").remove();
        }
        if (!close_button) {
            d.find("[w-role=close_button]").remove();
        }
        // if (close_backdrop) {
        //     d.find("[w-role=backdrop]").attr("data-micromodal-close", "true");
        // }
        if (custom_html) {
            d.find("[w-role=custom_html]").html(custom_html);
        }
        if (background) {
            d.find("[w-role=header]").css('background-image', `url(${background})`);
        }
        if (title_color) {
            d.find("[w-role=title]").css('color', `${title_color}`);
        }
        // TODO createForm(d.find("[w-role=form]"), form);
        if (form.length > 0) {
            this.createForm(d.find("[w-role=form]"), form);
        }

        if (buttons.length) {
            var $group = d.find('[w-role=button_group]');
            $group.addClass('box-btn-' + buttons.length)
            for (var btn of buttons) {
                var $btn = $(`<a class="btn-popup" style="color: ${btn.color}; background: ${btn.background}">${btn.name}</a>`);
                $group.append($btn);
                if (typeof btn.handler === 'function') {
                    $btn.on('click', btn.handler)
                }
                if (typeof btn.url === 'string') {
                    $btn.attr('href', btn.url);
                    $btn.attr('target', '_blank');
                }
                if (btn.id) {
                    $btn.attr('id', btn.id);
                }
                if (btn.class) {
                    $btn.addClass(btn.class);
                }
            }
        }

        // Chèn vô html w-reward
        var id = options.id;
        if (!id) {
            // Tạo modal có id random, show lên, modal này sẽ bị remove khi closed
            id = "modal-" + Date.now();
        }
        d.attr("id", id);
        titleHash[id] = options.title || id;
        return id;
    }

    showModal(id) {
        isOpenModal = true;
        this.eventBus.emit('modal-before-show', {
            id: id,
            title: titleHash[id],
        })
        MicroModal.show(id, {
            onClose: () => {
                if (modalQueue.length) {
                    const id = modalQueue.shift();
                    setTimeout(() => this.showModal(id), 100);
                } else {
                    isOpenModal = false;
                }
                // console.log('modal random show');
                this.eventBus.emit('modal-after-show', {
                    id: id,
                    title: titleHash[id],
                })
            }
        });
    }

    pushModal(opt) {
        let id = '';
        if (typeof opt == 'string') {
            id = opt;
        } else {
            id = this.createModal(opt);
            if (!id) {
                console.trace('createModal null');
            }
        }

        if (!modalQueue.length && !isOpenModal) {
            this.showModal(id);
            return;
        }
        modalQueue.push(id);
        console.log('modalQueue', modalQueue);
    }

    createForm($form, form) {
        for (var field of form) {
            const inputTag = parseInputTag(field);
            $form.append(`<div class="w-form-group floating">
                    ${inputTag}
                    <label>${field.name}</label>
                    ${field.required ? '<span class="w-required">*</span>' : ""}
                    <div class="w-error-log">Vui lòng nhập đủ thông tin</div>
                </div>`)
            if (field.key == 'phone' && field.enabled) {
                let input = document.querySelector('input[data-filter]');
                let state = {
                    value: input.value,
                    start: input.selectionStart,
                    end: input.selectionEnd,
                    pattern: RegExp('^' + input.dataset.filter + '$')
                };

                input.addEventListener('input', event => {
                    if (state.pattern.test(input.value)) {
                        state.value = input.value;
                    } else {
                        input.value = state.value;
                        input.setSelectionRange(state.start, state.end);
                    }
                });

                input.addEventListener('keydown', event => {
                    state.start = input.selectionStart;
                    state.end = input.selectionEnd;
                });
            }
            $('.w-form-group label').each(function () {
                var textSize = $(this).text().length;
                if (textSize > 35) {
                    $(this).addClass('overtype');
                    $(this).parent().addClass('oversize');
                }
            });
        }

        $form.find('input, select')
            .on('focus', function () {
                $(this).parent().removeClass('error');
            })
    }


    appendCountDownBar(code_position) {
        var countdownBarHTML = '<div id="reward-code-countdown-ctn" class="countdown-wrapper" style="display:none; ' + code_position + ':0;">' +
            '<div class="close">x</div>' +
            '<span id="reward-code-content">Mã coupon của bạn là: <strong id="countdown-code"></strong> sẽ hiển thị trên website trong vòng </span>' +
            '<span class="countdown" id="reward-code-countdown">' +
            '<span class="timer"><span id="countdown-minutes"></span>:<span id="countdown-seconds"></span></span></span></div>';

        if ($('#reward-code-countdown-ctn').length) {
            $('#reward-code-countdown-ctn').remove()
        }
        $('body').append(countdownBarHTML);
        $(document).on('click', '#reward-code-countdown-ctn .close', this.closeCountdown);
    }

    closeCountdown() {
        $('#reward-code-countdown-ctn').css('display', 'none');
    }

    showCountDownBar(expiredTime, rewardCode) {
        var t = expiredTime - 0;
        var duration = new Date(isNaN(t) ? expiredTime : t) - Date.now();
        $('#reward-code-countdown-ctn').css('display', 'block');
        fn();
        var x = setInterval(fn, 1000)

        function fn() {
            if (duration < 0) {
                clearInterval(x);
                closeCountdown();
            }
            var minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((duration % (1000 * 60)) / 1000);

            // Check xem xài date-fns được không
            if (minutes < 10) minutes = '0' + minutes;
            if (seconds < 10) seconds = '0' + seconds;
            var timeRemain = minutes + ":" + seconds;

            $("#reward-code-countdown").html(timeRemain);
            $('#countdown-code').html(rewardCode);
            duration -= 1000;
        }
    }
}

function getInputType(k) {
    if (k == 'phone' || k == 'tel') return 'tel';
    if (k == 'email') return 'email';
    if (k == 'number') return 'number';
    return 'text';
}

function parseInputTag(field) {
    if (field.type != 'select') {
        const type = getInputType(field.key);
        if (field.key == 'phone') {
            return `<input 
            type="${type}" placeholder=" " data-filter='([\+]|([\+][1-9])?[0-9]*)'
            class="w-${field.key}" name="${field.key}" 
            data-name="${field.name}"  ${field.required ? 'required' : ''}></input>`;
        }
        return `<input 
            type="${type}" placeholder=" " 
            class="w-${field.key}" name="${field.key}" 
            data-name="${field.name}"  ${field.required ? 'required' : ''}></input>`;
    }

    // SELECT
    let html = `<select class="w-form-control w-${field.key}" data-name="${field.name}" name="${field.key}"
        ${field.required ? "required" : ""}/>`;
    if (field.key !== 'province' && field.key !== 'district') {
        if (field.options) {
            html += `<option value=""></option>`;
            var options = field.options.split(',');
            options.forEach(function (option) {
                html += `<option value="${option}">${option}</option>`
            })
        }
    }
    html += '</select>';
    return html;
}